import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../utils/services/api.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.css']
})
export class OrganizationListComponent implements OnInit {

  public organizations;
  public viewType;
  public filteredData;

  constructor(private apiService: ApiService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.viewType = this.activatedRoute.snapshot.data.viewType;

    switch (this.viewType) {
      case 'ORGANIZATION':
        this.apiService.getOrganizations('Organization').subscribe(
          response => {
            this.organizations = response['data'];
            this.filteredData = this.organizations;
          }, error => {
            this.organizations = [];
            this.filteredData = this.organizations;
          }
        );
        break;
      case 'AGENCY':
        this.apiService.getOrganizations('Agency').subscribe(
          response => {
            this.organizations = response['data'];
            this.filteredData = this.organizations;
          }, error => {
            this.organizations = [];
            this.filteredData = this.organizations;
          }
        );
        break;
    }


  }

  searchText(text) {
    if (text && text.length > 2) {
      text = text.toLowerCase();
      this.filteredData = this.organizations.filter(org => org.name.toLowerCase().includes(text));
    } else {
      this.filteredData = this.organizations;
    }
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/organization-list/organization-list.component.ts